$('[data-widget="copy"]').each((i, element) => {
    const $element = $(element);
    const stringToCopy = $element.data('copy-string');
    const elementToCopy = $element.data('copy-element-text');
    const title = $element.attr('title') || 'Copy to clipboard';
    const actualString = stringToCopy ? stringToCopy : $(elementToCopy).text();

    if (actualString) {
        $element.attr('title', title);
        $element.tooltip();
        $element.on('click', (e) => {
            e.preventDefault();
            copy($element, actualString);
        });
    }
});

function copy($element, string) {
    if (string) {
        const el = document.createElement('textarea');
        el.value = string;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        $element.tooltip('dispose');

        const oldTitle = $element.data('original-title');
        $element.attr('title', 'Copied!');
        $element.tooltip({ trigger: 'manual' }).tooltip('show');

        setTimeout(() => {
            $element.tooltip('dispose');
            $element.attr('title', oldTitle);
            $element.tooltip();
        }, 1500);
    }
}